import stingTokens from '@chargebee/sting-tokens';

/**
 * Typed accessor for Chargebee Sting color tokens, for use in JS/TS contexts
 * (chart configs, SVG fills, Emotion `css`, MUI `sx`) where a Tailwind class is
 * not an option. Prefer Tailwind classes (e.g. `tw-text-primary-600`) elsewhere.
 */
export const stingColors = stingTokens.colors;
